module.exports = __webpack_public_path__ + "img/icon_dci.c4884b19.png";